import React, { useEffect, useState, useRef } from "react";
import { ApiService } from "../../Components/Services/apiservices";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { BrowserView, MobileView } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import constant from "../../Components/Services/constant";

function HomeCollectionSlider() {
  const [resCollectionSliderData, setResCollectionSliderData] = useState([]);
  const [mobileSliderData, setMobileSliderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");

  const swiperRef = useRef(null);
  const swiperRefMob = useRef(null);

  useEffect(() => {
    getCollectionSliderData();
  }, []);

  const getCollectionSliderData = () => {
    setLoading(true);

    ApiService.fetchData("home-collection-banner-list")
      .then((res) => {
        if (res.status === "success") {
          setResCollectionSliderData(res.resTopBannerData || []);
          setMobileSliderData(res.resMobileBannerData || []);
          setImageUrl(res.slider_image_path);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  // 🔹 Reset filter + redirect
  const resetFilter = (redirectUrl) => {
    localStorage.clear();
    if (redirectUrl) {
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 100);
    }
  };

  // 🔹 Common Image Render
  const renderImage = (value, url, index) => (
    <SwiperSlide key={index}>
      <div className="item">
        <a onClick={() => resetFilter(url)} style={{ cursor: "pointer" }}>
          <img
            src={
              value.slider_image
                ? imageUrl + value.slider_image
                : constant.DEFAULT_IMAGE
            }
            className="img-fluid w-100"
            alt={value.slider_name}
          />
        </a>
      </div>
    </SwiperSlide>
  );

  // 🔹 Dynamic logic
const renderCarouselItem = (value, index) => {
  if (value.slider_type == 1 && value.slider_url) {
    return renderImage(value, value.slider_url, index);
  } 
  else if (value.slider_type == 2 && value.category_slug) {
    return renderImage(value, "/category/" + value.category_slug, index);
  } 
  else if (value.slider_type == 3 && value.collection_slug) {
    return renderImage(value, "/collection/" + value.collection_slug, index);
  } 
  else {
    return renderImage(value, "#", index);
  }
};

  // 🔹 Controls
  const handlePrev = () => swiperRef.current?.slidePrev();
  const handleNext = () => swiperRef.current?.slideNext();
  const handlePrevmob = () => swiperRefMob.current?.slidePrev();
  const handleNextmob = () => swiperRefMob.current?.slideNext();

  return (
    <>
      {/* ================= DESKTOP ================= */}
      <BrowserView>
        <div className="gallerySlider position-relative">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            loop={true}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Autoplay]}
          >
            {loading ? (
              <SwiperSlide>
                <Skeleton height={400} />
              </SwiperSlide>
            ) : (
              resCollectionSliderData.map((value, index) =>
                renderCarouselItem(value, index)
              )
            )}
          </Swiper>

          <div className="swiper-arrow">
            <div className="prev-arrow" onClick={handlePrev}>
              <img src="/img/leftarrow.svg" alt="prev" />
            </div>
            <div className="next-arrow" onClick={handleNext}>
              <img src="/img/rightarrow.svg" alt="next" />
            </div>
          </div>
        </div>
      </BrowserView>

      {/* ================= MOBILE ================= */}
      <MobileView>
        <div className="gallerySlider position-relative">
          <Swiper
            onSwiper={(swiper) => (swiperRefMob.current = swiper)}
            loop={true}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Autoplay]}
          >
            {loading ? (
              <SwiperSlide>
                <Skeleton height={300} />
              </SwiperSlide>
            ) : (
              mobileSliderData.map((value, index) =>
                renderCarouselItem(value, index)
              )
            )}
          </Swiper>

          <div className="swiper-arrow">
            <div className="prev-arrow" onClick={handlePrevmob}>
              <img src="/img/leftarrow.svg" alt="prev" />
            </div>
            <div className="next-arrow" onClick={handleNextmob}>
              <img src="/img/rightarrow.svg" alt="next" />
            </div>
          </div>
        </div>
      </MobileView>
    </>
  );
}

export default HomeCollectionSlider;